import React, { useEffect, useRef, useState } from 'react'
import { headerStyle } from '../css/styles/componentStyles';
import { allHeaderTab, navTabs } from '../utils/string';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import ReplyIcon from '@mui/icons-material/Reply';
import { ArrowBack } from '@mui/icons-material';
function Header({ selectedTab, setSelectedTab, selectedMonthTab, setSelectedMonthTab, handeNavbarState }) {
  const [months, setMonths] = useState([]);
  const monthsScrollRef = useRef(null);



  const generateMonths = () => {
    const currentDate = new Date();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const fullMonthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    const generatedMonths = [];

    for (let i = 0; i < (12 * 5); i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const shortMonth = monthNames[date.getMonth()];
      const year = date.getFullYear().toString();
      const monthValue = `${fullMonthNames[date.getMonth()]} ${year}`;

      generatedMonths.push({ month: shortMonth, year, monthValue });
    }

    setMonths(generatedMonths.reverse());



  };
  useEffect(() => {

    generateMonths();
  }, []);
  useEffect(() => {
    if (monthsScrollRef.current && months.length > 0) {

      setTimeout(() => {
        if (monthsScrollRef.current) {
          monthsScrollRef.current.scrollLeft = monthsScrollRef.current.scrollWidth;
        }
      }, 100);
    }
  }, [months]);

  const handleBack = (e) => {
    handeNavbarState(e, "expense")
  }

  const selectedMonthTabHandler = (item) => {
    if (item.monthValue === selectedMonthTab.monthValue) {
      setSelectedMonthTab({});
    } else {
      setSelectedMonthTab(item)
    }
  }


  return (
    <div className="shadow" style={{ ...headerStyle.headerContainer, padding: '16px', color: '#fff', position: 'fixed', top: '71px', width: '100%', zIndex: 999, boxShadow: '3px 5px 10px 0 #eee' }}>
      <div className="container-fluid">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', padding: '10px' }}>

          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '0', alignItems: 'center' }}>
            <div>
              <ReplyIcon style={{ fontSize: '30px', marginRight: '20px', cursor: 'pointer' }} onClick={(e) => handleBack(e)} />
            </div>
            {navTabs.map((tab) => (
              <button
                key={tab.id}
                className={`btn `}
                onClick={() => setSelectedTab(tab.id)}
                style={{ display: 'flex', alignItems: 'center', marginRight: '16px', padding: '8px 16px', border: selectedTab === tab.id ? "1px solid #ffc107" : "", color: selectedTab === tab.id ? "#ffc107" : "#fff" }}
              >
                <span style={{ marginRight: '8px' }}>
                  {tab.icon === 'grid' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-grid" viewBox="0 0 16 16">
                      <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z" />
                    </svg>
                  )}
                  {tab.icon === 'file-text' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-text" viewBox="0 0 16 16">
                      <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
                    </svg>
                  )}
                  {tab.icon === 'calendar' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar" viewBox="0 0 16 16">
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  )}
                  {tab.icon === 'edit' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                    </svg>
                  )}
                </span>
                {tab.label}
              </button>
            ))}
          </div>

          {/* <div style={{display:"flex",flexWrap:'wrap',justifyContent:'center',alignItems:'center'}}>
            {months.map((item, index) => (
              <div key={index} style={{cursor:"pointer",textAlign:"center",margin:'0 4px',flexDirection:'column',alignItems:'center'}} onClick={()=>selectedMonthTabHandler(item)}>
                <div style={{fontSize:'12.25px',marginBottom:'4px',color: (selectedMonthTab.month === item.month && selectedMonthTab.year === item.year) ? "#ffc107":"#fff"}}>{item.month}</div>
                <div style={{fontSize:'12.25px',color: (selectedMonthTab.month === item.month && selectedMonthTab.year === item.year) ? "#ffc107":"#fff"}}>{item.year}</div>
              </div>
            ))}
          </div> 
          <div
            ref={monthsScrollRef}
            style={{
              display: "flex",
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              overflowX: 'auto',
              maxWidth: '400px',
              paddingBottom: '8px'
            }}>
            {months.map((item, index) => (
              <div
                key={index}
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  margin: '0 8px',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minWidth: '40px',
                  flexShrink: 0
                }}
                onClick={() => selectedMonthTabHandler(item)}
              >
                <div style={{
                  fontSize: '12.25px',
                  marginBottom: '4px',
                  color: (selectedMonthTab.month === item.month && selectedMonthTab.year === item.year) ? "#ffc107" : "#fff"
                }}>
                  {item.month}
                </div>
                <div style={{
                  fontSize: '12.25px',
                  color: (selectedMonthTab.month === item.month && selectedMonthTab.year === item.year) ? "#ffc107" : "#fff"
                }}>
                  {item.year}
                </div>
              </div>
            ))}
          </div>
          */}

          <div
            ref={monthsScrollRef}
            style={{
              display: "flex",
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              overflowX: 'auto',
              maxWidth: '400px',
              paddingBottom: '12px',
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(255, 193, 7, 0.5) transparent',
              WebkitScrollbar: {
                height: '4px'
              },
              position: 'relative',
              background: 'linear-gradient(90deg, rgba(0,0,0,0.1) 0%, transparent 20%, transparent 80%, rgba(0,0,0,0.1) 100%)',
              borderRadius: '12px',
              padding: '8px 12px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.1)'
            }}>
            {months.map((item, index) => {
              const isSelected = (selectedMonthTab.month === item.month && selectedMonthTab.year === item.year);
              return (
                <div
                  key={index}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    margin: '0 6px',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '50px',
                    flexShrink: 0,
                    padding: '8px 12px',
                    borderRadius: '10px',
                    background: isSelected 
                      ? 'linear-gradient(135deg, #ffc107 0%, #ffb300 100%)' 
                      : 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    border: isSelected 
                      ? '2px solid #ffc107' 
                      : '1px solid rgba(255,255,255,0.1)',
                    transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: isSelected 
                      ? '0 4px 12px rgba(255, 193, 7, 0.3), 0 2px 4px rgba(0,0,0,0.1)' 
                      : '0 2px 4px rgba(0,0,0,0.1)',
                    backdropFilter: 'blur(8px)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onClick={() => selectedMonthTabHandler(item)}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.target.style.transform = 'scale(1.02)';
                      e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.1) 100%)';
                      e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }
                  }}
                >
                 
                  {isSelected && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                      animation: 'shimmer 2s infinite',
                      '@keyframes shimmer': {
                        '0%': { left: '-100%' },
                        '100%': { left: '100%' }
                      }
                    }} />
                  )}
                  
                  <div style={{
                    fontSize: '13px',
                    fontWeight: isSelected ? '700' : '500',
                    marginBottom: '2px',
                    color: isSelected ? "#000" : "#fff",
                    textShadow: isSelected ? 'none' : '0 1px 2px rgba(0,0,0,0.3)',
                    letterSpacing: '0.5px',
                    position: 'relative',
                    zIndex: 1
                  }}>
                    {item.month}
                  </div>
                  <div style={{
                    fontSize: '11px',
                    fontWeight: isSelected ? '600' : '400',
                    color: isSelected ? "#000" : "rgba(255,255,255,0.9)",
                    textShadow: isSelected ? 'none' : '0 1px 2px rgba(0,0,0,0.3)',
                    letterSpacing: '0.3px',
                    position: 'relative',
                    zIndex: 1
                  }}>
                    {item.year}
                  </div>
                </div>
              );
            })}
            
           
          </div>

        </div>
      </div>
    </div>
  );
}

export default Header;